<template>
    <div class="preloadPage">
        <div class="preloadWrapper">
            <div class="percentBar">
                <div ref="percentBar"></div>
            </div>
            <p class="percent">{{percent}}%</p>
        </div>
    </div>
</template>

<script>
import {TweenMax} from 'gsap'
import projectsList from '../Projects/projects'

export default {
    name: 'Preloader',
    data () {
        return {
            percent: 0
        }
    },
    mounted: function(){
        let images = []

        for(let i = 0; i < projectsList.length; i++)
            images.push(projectsList[i].fullImage)

        this.preloadImages(images, _ => {
            setTimeout(_ => {
                this.$emit('updateLoaderState')
            }, 500)
        })
    },
    methods: {
        preloadImages: function(sources, callback){

            // load all images in this virtualEl
            var imgs = [],
                img,
                remaining = sources.length;

            for(var i = 0; i < sources.length; i++) {
                img = new Image();
                imgs.push(img);

                img.onload = _ => {
                    remaining--

                    let percent = (sources.length - remaining) / sources.length
                    this.percent = Math.round(percent * 100)

                    TweenMax.to(this.$refs.percentBar, 0.3, {width: this.percent+'%'})

                    if (remaining == 0)
                        callback()
                }

                img.onerror = (error) => {
                    console.error('Preload error with this image : '+ error.path[0].src)
                    remaining--
                }

                img.src = require('../../assets/images/projects/'+sources[i]);
            }

            if(remaining === 0)
                callback()
        }
    }
}
</script>

<style lang="scss">
    @import './preloader';
</style>



// WEBPACK FOOTER //
// src/components/Preloader/Preloader.vue